import { render, staticRenderFns } from "./stockoutChanges_review.vue?vue&type=template&id=548ebcdb&scoped=true&"
import script from "./stockoutChanges_review.vue?vue&type=script&lang=js&"
export * from "./stockoutChanges_review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548ebcdb",
  null
  
)

export default component.exports